// Refund Enums
export enum FormStatus {
  UNSENT = 'unsent',
  SUCCESSFUL_REFUND = 'successfulRefund',
  FAILED_REFUND = 'failedRefund',
}

export enum RefundReason {
  NEVER_ARRIVED = 'Order never arrived',
  MISSING_ITEMS = 'Missing items',
}
